import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
const SubscribeConfirmation = ({ isOpen, onClose, onConfirm, payload }) => {
  const {t}= useTranslation();

  if (!isOpen) return null;
  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="flex flex-col items-center bg-white rounded-lg shadow-lg p-6 w-4/5">
        <h2 className="w-full  text-center text-xl font-bold mb-4">{payload.subscription_name} - {payload.subscription_cost} QAR</h2>
        <div className="h-[2px] w-full  bg-gray-700" ></div>
        <p className="mb-4">{t('wantproceed')} </p>

        <div className="flex justify-center flex-wrap space-x-2 gap-1">
          <button
            className="bg-orange-500 w-full text-white px-4 py-2 rounded-full hover:bg-orange-700"
            onClick={onClose}
          >
            {t('cancel')}
          </button>
          <button
            className="bg-blue-400 w-full text-white px-4 py-2 rounded-full hover:bg-blue-700"
            onClick={onConfirm}
          >
           {t('pay')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SubscribeConfirmation;
